import $ from 'cash-dom';

$('[data-action="show-panel"]').on('click', function () {
	let group = this.getAttribute('data-panel-group-title');
	let showPanel = this.getAttribute('data-panel-name');
	let panels = $(`[data-panel-group="${group}"]`);
	panels.attr('aria-hidden', 'true').css('display', 'none');
	$(`[data-element="${showPanel}"]`).attr('aria-hidden', 'false').css('display', 'block');
});
